import Opportunities from 'components/opportunities'
import SignRequests from 'components/sign-requests'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    can: 'read opportunities',
    template: 'chameleon'
  },
  [
    {
      path: '/opportunities',
      component: Opportunities.Opportunities,
      name: 'opportunities.index',
      meta: {
        template: 'chameleon',
        can: 'read opportunities'
      }
    },
    // {
    //   path: '/opportunities/add',
    //   component: Opportunities.Add,
    //   name: 'opportunities.add',
    //   meta: {
    //     template: 'chameleon',
    //     can: 'write opportunities'
    //   }
    // },
    {
        path: '/opportunities/:opportunity_id',
        component: Opportunities.Show,
        name: 'opportunities.show',
        children: [
            {
            path: 'overview',
            component: Opportunities.Overview,
                name: 'opportunities.overview',
          },
            {
            path: 'costing',
            component: Opportunities.Costing,
                name: 'opportunities.costing',
            },
            {
            path: 'quote',
            component: Opportunities.Quote,
                name: 'opportunities.quote',
            },
            {
            path: 'document-signing/:sign_request_id',
            component: SignRequests.DocumentSigning,
                name: 'opportunities.document-signing',
            }
        ]
    }
  ])
